import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Form2.css";

const Form2 = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    departureCity: "",
    destination: "",
    alternateDestination: "",
    startDate: "",
    endDate: "",
    days: "",
    nights: "",
    dateType: "",
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const validate = () => {
    let err = {};

    if (!formData.departureCity.trim())
      err.departureCity = "Departure city is required";

    if (!formData.destination.trim())
      err.destination = "Destination is required";

    if (!formData.startDate) err.startDate = "Start date is required";

    if (!formData.endDate) err.endDate = "End date is required";

    if (formData.startDate && formData.endDate) {
      if (new Date(formData.endDate) < new Date(formData.startDate)) {
        err.endDate = "End date cannot be before start date";
      }
    }

    if (!formData.days) err.days = "Number of days is required";
    else if (formData.days <= 0) err.days = "Invalid days";

    if (!formData.nights) err.nights = "Number of nights is required";
    else if (formData.nights < 0) err.nights = "Invalid nights";

    if (!formData.dateType) err.dateType = "Please select Fixed or Flexible";

    setErrors(err);
    return Object.keys(err).length === 0;
  };


const handleSubmit = (e) => {
  e.preventDefault();

  const isValid = validate();

  if (isValid) {
    navigate("/form3");
  }
};

  return (
    <div className="travel-container">
      <div className="travel-left">
        <h1>Travel Location Details</h1>
      </div>

      <div className="travel-right">
        <form className="travel-form" onSubmit={handleSubmit}>
          <label>Departure City</label>
          <input
            type="text"
            name="departureCity"
            placeholder="Enter your departure city"
            value={formData.departureCity}
            onChange={handleChange}
          />
          {errors.departureCity && (
            <p className="error">{errors.departureCity}</p>
          )}

          <label>Destination (Primary)</label>
          <input
            type="text"
            name="destination"
            placeholder="Enter your primary destination"
            value={formData.destination}
            onChange={handleChange}
          />
          {errors.destination && <p className="error">{errors.destination}</p>}

          <label>Alternate Destination (Optional)</label>
          <input
            type="text"
            name="alternateDestination"
            placeholder="Enter an alternative destination (if any)"
            value={formData.alternateDestination}
            onChange={handleChange}
          />

          <label>Travel Start Date</label>
          <input
            type="date"
            name="startDate"
            value={formData.startDate}
            onChange={handleChange}
          />
          {errors.startDate && <p className="error">{errors.startDate}</p>}

          <label>Travel End Date</label>
          <input
            type="date"
            name="endDate"
            value={formData.endDate}
            onChange={handleChange}
          />
          {errors.endDate && <p className="error">{errors.endDate}</p>}

          <label>Number of Days</label>
          <input
            type="number"
            name="days"
            placeholder="Enter the number of days"
            value={formData.days}
            onChange={handleChange}
          />
          {errors.days && <p className="error">{errors.days}</p>}

          <label>Number of Nights</label>
          <input
            type="number"
            name="nights"
            placeholder="Enter the number of nights"
            value={formData.nights}
            onChange={handleChange}
          />
          {errors.nights && <p className="error">{errors.nights}</p>}

          <label>Fixed Dates or Flexible Dates</label>
          <div className="date-type-buttons">
            <button
              type="button"
              className={formData.dateType === "Fixed" ? "active" : ""}
              onClick={() => setFormData({ ...formData, dateType: "Fixed" })}
            >
              Fixed
            </button>
            <button
              type="button"
              className={formData.dateType === "Flexible" ? "active" : ""}
              onClick={() => setFormData({ ...formData, dateType: "Flexible" })}
            >
              Flexible
            </button>
          </div>
          {errors.dateType && <p className="error">{errors.dateType}</p>}

          <div className="button-group">
            <button
              type="button"
              className="back-btn"
              onClick={() => navigate(-1)}
            >
              Back
            </button>

            <button type="submit" className="next-btn">
              Next
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Form2;
